module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Satan's_Lullaby2#Contents-A"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "fp para-style-override-3"
  }, [_vm._v("It is difficult to fight against anger,"), _c('br'), _vm._v("for a man will buy revenge with his soul.")]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-4"
  }, [_vm._v("—Heraclitus, quoted in Aristotle’s "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Politics"), _c('br')]), _vm._v("(Trans. Benjamin Jowett)"), _c('span', {
    staticClass: "Italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f0566ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Satans_Lullaby5.vue
// module id = 75
// module chunks = 0